import {
  SecondaryColor, maxTablet, maxWidth, midTablet, primaryColor, primaryFont,
  primaryHeadingColor, retina, scrollbar, secondaryFont, wMBold, wMedium,
} from 'Utils/utilsStyle';
import styled from 'styled-components';
import AccountStrategyIcon from 'Components/common/assets/svgIcons/AccountStrategyIcon';
import AccountMapIcon from 'Components/common/assets/svgIcons/AccountMapIcon';
import ChallengesAndPainPoints from 'Components/common/assets/svgIcons/ChallengesAndPainPoints';
import SolutionAlignment from 'Components/common/assets/svgIcons/SolutionAlignment';
import GrowthStrategy from 'Components/common/assets/svgIcons/GrowthStrategy';
import AccountOverview from 'Components/common/assets/svgIcons/AccountOverview';
import FinancialSummary from 'Components/common/assets/svgIcons/FinancialSummary';
import CompetitorAnalysis from 'Components/common/assets/svgIcons/CompetitorAnalysis';
import SWOTAnalysis from 'Components/common/assets/svgIcons/SWOTAnalysis';
import BusinessCase from 'Components/common/assets/svgIcons/BusinessCase';
import BuyerAnalysis from 'Components/common/assets/svgIcons/BuyerAnalysis';
import BusinessSegments from 'Components/common/assets/svgIcons/BusinessSegments';
import BusinessRisks from 'Components/common/assets/svgIcons/BusinessRisks';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { selectDisclessPersonality } from 'Selector/GlobalSearchContentSelector';

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  overflow: auto;
  justify-content: center;
  ${scrollbar};
  flex: 1;
  margin-right: 5px;

  .timeline-contentWrapper{
    &.nutenixTimeline {
      .timeline-cell-div {
        /* &::before {
          height: calc(100% - 199px);
          @media all and (max-width:${maxWidth}), ${retina} {
            height: calc(100% - 163px);
          }
        } */
        &:last-child {
          .child-of-cells {
            visibility: hidden;
          }
        }
      }
    }
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-left: 40px;
    margin-top: 12px;
    height: max-content;

    @media all and (max-width:${maxWidth}), 
    ${retina} {
      margin-top: 8px;
    }
    @media all and (max-height: ${midTablet}) {
      margin-top: 0px;
    }
    .timeline-heading {
    font-size: 26px;
    font-family: ${secondaryFont};
    font-weight: ${wMBold};
    margin-bottom: 2px;
    display: flex;
    justify-content: center;
    color: ${SecondaryColor};
    position: relative;
    align-self: center;
    margin-left: -40px;
    height: 40.84px;
    @media all and (max-height: ${midTablet}) {
      font-size: 24px;
      line-height: 39px;
    }
    @media all and (max-width:${maxWidth}), ${retina} {
      font-size: 23px;
      line-height: 36px;
      height: unset;
    }
    }
    .timeline-cell-div {
      width: 100%;
      &::before {
      content: "";
      position: absolute;
      width: 1px;
      top: 65px;
      height: calc(100% - 147px);
      right: calc(100% + 44px);
      background-color: ${primaryColor};
      @media all and (max-width:${maxWidth}), ${retina} {
        top: 52px;
        width: 1px;
        height: calc(100% - 121.5px);
        right: calc(100% + 43px);
      }
      @media all and (max-width: ${maxTablet}) and (max-height: ${midTablet}) {
        right: calc(100% + 42px);
      }
    }
    .child-of-cells {
      display: flex;
      flex-direction: column;
      width: calc(100% - 0px);
      padding-left: 60px;
      position: relative;
      @media all and (max-width:${maxWidth}), ${retina} {
        padding-left: 50px;
      }
      &::before {
        content: "";
        position: absolute;
        width: 1px;
        background-color: ${primaryColor};
        height: calc(100% - 19px);
        top: -11px;
        right: calc(100% - 21px);
        @media all and (max-width:${maxWidth}), ${retina} {
          width: 0.5px;
          right: calc(100% - 16px);
          height: calc(100% - 16px);
        }
        @media all and (max-width:${maxWidth}){
          right: calc(100% - 16px);
        }
      }
      .timeline-cell {
        &::before {
          right: calc(100% + 14px);
          width: 26px;
          z-index: 1;
          @media all and (max-width:${maxWidth}), ${retina} {
            width: 20px;
            height: 0.5px;
          }
        }
        &::after {
          color: #ade9c0;
        }
        .cell-heading {
          box-shadow: none;
          font-size: 14px;
          line-height: 18px;
          @media all and (max-width:${maxWidth}), ${retina} {
            font-size: 12px;
            line-height: 19px;
          }
        }
      }
    }
    .timeline-cell {
      position: relative;
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      max-height: 42px;
      @media all and (max-width:${maxWidth}), ${retina} {
        max-height: 33px;
      }
      .svg-icon-cell {
        z-index: 1;
        height: 42px;
        min-width: 42px;
        @media all and (max-width:${maxWidth}), ${retina} {
          height: 32px;
          min-width: 33px;
        }
        svg {
          height: 42px;
          width: 42px;
          @media all and (max-width:${maxWidth}), ${retina} {
            height: 33px;
            width: 33px;
          }
        }
      }
      &::before {
        content: "";
        position: absolute;
        width: 23px;
        top: 21px;
        height: 1px;
        background-color: ${primaryColor};
        right: calc(100% + 22px);
        @media all and (max-width:${maxWidth}), ${retina} {
          top: 14px;
          right: calc(100% + 20px);
          height: 0.5px;
        }
      }
      &::after {
        content: "•";
        color: ${primaryColor} !important;
        position: absolute;
        font-size: 45px;
        top: -8px;
        right: calc(100% + 8px);
        text-shadow: 0px 0px 4px ${primaryColor};
        @media all and (max-width:${maxWidth}), ${retina} {
          font-size: 37px;
          top: -9px;
        }
      }
      .cell-heading {
        position: relative;
        color: ${primaryHeadingColor};
        font-family: ${primaryFont};
        font-size: 16px;
        line-height: 18px;
        font-weight: ${wMedium};
        width: 100%;
        margin: 0px;
        padding: 12px 25px 12px 55px;
        border: 1px solid ${primaryColor};
        border-radius: 23px;
        height: 41px;
        margin-left: -42px;
        box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.16);
        @media all and (max-width:${maxWidth}), ${retina} {
          height: 32px;
          margin-left: -33px;
          font-size: 14px;
          line-height: 16px;
          padding: 7px 20px 5px 40px;
        }
      }
    }
  }
}  
 
`;

const SmartAccountDrawerTimeline = function SmartAccountDrawerTimeline() {
  const disclessPersonality = useSelector(selectDisclessPersonality);
  const timeline = [
    {
      heading: 'Account Overview',
      icon: <AccountOverview />,
      children: [
        {
          heading: 'Financial Summary',
          icon: <FinancialSummary />,
        },
        {
          heading: 'Business Segments',
          icon: <BusinessSegments />,
        },
        {
          heading: 'Business Risks',
          icon: <BusinessRisks />,
        },
        {
          heading: 'Competitor Analysis',
          icon: <CompetitorAnalysis />,
        },
        {
          heading: 'SWOT Analysis',
          icon: <SWOTAnalysis />,
        },
        {
          heading: 'Growth Opportunities',
          icon: <GrowthStrategy />,
        },
        {
          heading: 'Challenges and Pain points',
          icon: <ChallengesAndPainPoints />,
        },
      ],
    }, {
      heading: 'Account Strategy',
      icon: <AccountStrategyIcon />,
      children: [
        {
          heading: 'Solution Alignment',
          icon: <SolutionAlignment />,
        },
        {
          heading: 'Business Case',
          icon: <BusinessCase />,
        },
      ],
    }, {
      heading: 'Buyer Group',
      icon: <AccountMapIcon />,
      children: [
        {
          heading: 'Buyer Analysis',
          icon: <BuyerAnalysis />,
        },
      ],
    }];

  return (
    <Wrapper>
      <div className={classNames('timeline-contentWrapper', { nutenixTimeline: disclessPersonality })}>
        <h6 className="timeline-heading">Sections</h6>
        {timeline.map((section) => (
          <div className="timeline-cell-div">
            <div className="timeline-cell">
              <span className="svg-icon-cell">{section.icon}</span>
              <p className="cell-heading text-truncate">{section.heading}</p>
            </div>
            <div className="child-of-cells">
              {section.children.map((secChild) => (
                <div className="timeline-cell">
                  <span className="svg-icon-cell">{secChild.icon}</span>
                  <p className="cell-heading text-truncate">{secChild.heading}</p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </Wrapper>
  );
};

export default SmartAccountDrawerTimeline;
